import React from 'react'
import styles from './SuccessMessage.module.scss'

export const SuccessMessage = (props: {
  children: React.ReactNode
}): JSX.Element => {
  const { children: childComponents } = props
  return <div className={styles.MessageContainer}>{childComponents}</div>
}
